import React from 'react';
import { useSelector } from 'react-redux';
// import Breadcrumbs from 'components/Common/Breadcrumbs/Breadcrumbs';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import { H1Title, SubTitle } from 'components/Common';
import styles from './CategoryPageHeader.module.scss';

const CategoryPageHeader = () => {
  const currentCategory = useSelector(getCurrentCategory);

  return (
    <div className={styles.container}>
      {/* <Breadcrumbs /> */}
      <div className={styles.text}>
        <H1Title>{currentCategory?.title}</H1Title>
        <SubTitle>{currentCategory?.subTitle}</SubTitle>
      </div>
    </div>
  );
};

export default CategoryPageHeader;
